<div class="l-flex l-flex-wrap t-panel l-align-y t-row--med">
  <input-wrap [loading]="agentsList && agentsList.loading">
    <p-select
      [options]="agentsList"
      [(ngModel)]="selectedAgent"
      [filter]="true"
      [resetFilterOnHide]="true"
      filterBy="label,id"
      [placeholder]="'translate.general.agent' | translate"
      [optionLabel]="'label'"
      [filterPlaceholder]="'translate.general.search' | translate"
      (onChange)="search()"
      [appendTo]="'body'"
    ></p-select>
    <clear-multi
      *ngIf="selectedAgent"
      (click)="selectedAgent = null; search()"
    ></clear-multi>
  </input-wrap>
</div>

<lab-kpi
  *ngIf="filterType && !loading"
  #agentsKpi
  [tag]="'_agents'"
  [filter]="filter"
  [filterType]="filterType"
></lab-kpi>
